export default {
    hasPermission: state => (permissionName) => {
        return (state.user.permissions_names || []).indexOf(`tenant.${permissionName}`) >= 0;
    },
    hasPortalPermission: state => (permissionName) => {
        return (state.user.permissions_names || []).indexOf(`portal.${permissionName}`) >= 0;
    },
    getConfig: state => (name) => {
        const config = state.configs[name];

        if (config) {
            return config.value;
        } else {
            return null;
        }
    },
    getSortedList: state => (type) => {
        return Object.values(state[type]).sort((a, b) => a.order - b.order);
    },
    getCustomFields: state => (type) => {
        return Object.values(state.customFields).filter((field) => {
            return field.morphable_type === type;
        }).sort((a, b) => a.order - b.order);
    },
    getFilteredValue: state => (type, func) => {
        const res = Object.values(state[type]).filter(func);
        if (res.length) {
            return res[0];
        } else {
            return null;
        }
    },
    getFilteredValues: state => (type, func) => {
        return Object.values(state[type]).filter(func);
    },
    getUserConfig: state => (name) => {
        const config = state.user.configs[name];

        if (config) {
            return config.value;
        } else {
            return null;
        }
    },
};
